"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MenuHeader = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _IconActionDropDown = _interopRequireDefault(require("../../Icons/IconActionDropDown"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var MenuHeader = function MenuHeader(_ref) {
  var opened = _ref.opened,
      handleOpenClose = _ref.handleOpenClose,
      children = _ref.children,
      className = _ref.className,
      otherProps = _objectWithoutProperties(_ref, ["opened", "handleOpenClose", "children", "className"]);

  return /*#__PURE__*/_react.default.createElement(StyledMenuHeader, _extends({
    open: opened,
    className: className
  }, otherProps), children, /*#__PURE__*/_react.default.createElement(ToggleButton, {
    onClick: handleOpenClose,
    open: opened
  }, /*#__PURE__*/_react.default.createElement(_IconActionDropDown.default, {
    size: 22
  })));
};

exports.MenuHeader = MenuHeader;

var StyledMenuHeader = _styledComponents.default.div.withConfig({
  displayName: "StyledMenuHeader"
})(["display:flex;justify-content:space-between;align-items:center;background-color:white;border-top:1px solid ", ";border-bottom:1px solid ", ";transition:border-top 700ms cubic-bezier(1,0,0,1),border-bottom 700ms cubic-bezier(1,0,0,1);padding:1.5rem;height:7.5rem;"], function (_ref2) {
  var open = _ref2.open;
  return !open ? '#e4e4e4' : 'white';
}, function (_ref3) {
  var open = _ref3.open;
  return open ? '#e4e4e4' : 'white';
});

var ToggleButton = _styledComponents.default.a.withConfig({
  displayName: "ToggleButton"
})(["transform:", ";transition:transform 700ms cubic-bezier(1,0,0,1);cursor:pointer;flex:0 0 3rem;display:flex;justify-content:flex-end;align-items:center;svg path{stroke:", ";}"], function (_ref4) {
  var open = _ref4.open;
  return !open ? 'rotate(180deg)' : '';
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.brand.primary;
});

MenuHeader.propTypes = {
  opened: _propTypes.bool,
  handleOpenClose: _propTypes.func,
  children: _propTypes.node.isRequired,
  className: _propTypes.string,
  otherProps: _propTypes.object
};